import styled from "styled-components";

const PromotionStyles = styled.section`
    background: #000;
    .main-sec {
        color: #fff;
        padding: 4px 0;
        @media (min-width: 992px) {
            line-height: 1.5;
            letter-spacing: 1px;
        }
    }
`;

const HeaderStyles = styled.div`
    .main-sec {
        padding: 10px 0;
        .ct-sec {
            width: 180px;
            @media (min-width: 991px) {
                width: 260px;
            }
        }

        .rt-sec {
            .header-cart-details {
                .badge {
                    height: 22px;
                    width: 22px;
                    font-size: 9px;
                }
            }
        }
    }

    .sign-in-link {
        &:not(:last-child) {
            margin-right: 40px;
        }
        @media (max-width: 992px) {
            &:not(:last-child) {
                margin-right: 15px;
            }
        }

        a {
            color: #333;
            &:hover {
                color: #000;
            }
        }

        .st-dropdown-menu {
            position: absolute;
            top: 100%;
            right: 0;
            min-width: 150px;
            z-index: 1;
            display: none;
            .inner {
                background-color: #f9f9f9;
                border-radius: 5px;
                box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
                z-index: 111;

                .dm-link {
                    padding: 13px 15px;
                    border-bottom: 1px solid #ccc;
                    color: #333;
                    transition: 0.3s;
                    &:hover {
                        background-color: #efefef;
                    }
                }
            }

            @media (min-width: 991px) {
                right: initial;
                left: 50%;
                transform: translatex(-50%);
            }
        }

        &:hover {
            .st-dropdown-menu {
                display: block;
            }
        }
    }

    .sign-in-label {
        font-size: 12px;
        color: #333;
        text-decoration: none;
        &:hover {
            color: #000;
        }

        @media (max-width: 992px) {
            display: none;
        }
    }
`;

const HeaderSearch = styled.div`
    .search-box {
        border-bottom: 1px solid #666;
        height: 32px;
        width: 350px;
        input {
            outline: none;
            border: none;
            width: 100%;
        }

        @media (max-width: 992px) {
            position: fixed;
            top: -100%;
            left: 0;
            width: 100%;
            background: #fff;
            height: 45px;
            padding: 0 11px;
            z-index: 9;
            transition: 0.2s;
            .icon {
                font-size: 20px;
            }

            &.active {
                top: 0;
            }
        }
    }

    .search-dropdown {
        top: calc(100% + 5px);
        left: 0;
        width: 100%;
        z-index: 11;

        @media (max-width: 992px) {
            top: 46px;
            left: 3px;
            width: calc(100% - 6px);
            z-index: 9;
            position: fixed !important;
        }

        > .inner {
            background-color: #f9f9f9;
            border-radius: 5px;
            box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
            z-index: 111;
            overflow: hidden;
            min-height: 100px;
            max-height: 450px;
            overflow: auto;
            .item {
                &:not(:last-child) {
                    border-bottom: 1px solid #ccc;
                }
                transition: 0.3s;
                > .inner {
                    padding: 10px 15px;
                }
                &:hover {
                    > .inner {
                        background-color: #efefef;
                    }
                }
            }
            .img-sec {
                height: 45px;
                width: 45px;
                &:not(.loaded) {
                    background: #ddd;
                }
                img {
                    max-height: 100%;
                }
            }

            .text-sec {
                color: #333;
                transition: 0.3s;
            }
            .loading {
                top: 0;
                left: 0;
            }
        }
    }

    @media (min-width: 991px) {
        .search-dropdown {
            padding-right: 40px;
        }
    }
`;

const NavStyles = styled.div`
    .header-menu-inner {
        border-bottom: 1px solid #333;
        margin-bottom: 15px;
    }

    .menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1;
    }

    .nav-container-custom {
        transition: 0.2s;
        @media (max-width: 991px) {
            position: fixed !important;
            top: 0;
            left: 0;
            background: #fff;
            height: 100%;
            width: 300px;
            z-index: 99;
            flex-direction: column;
            padding: 10px;
            overflow-y: auto;
            box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.1);
            &:not(.active) {
                left: -100%;
            }
        }
    }

    .dropdown-main {
        position: relative;

        .label-outer {
            border: none;
            background: none;
            padding: 11px 12px;
            border-bottom: 4px solid transparent;
            color: #333;
        }

        .dropdown-content {
            display: none;
            position: absolute;
            left: 0;
            background-color: #f9f9f9;
            border-radius: 5px;
            padding: 5px;
            min-width: 100%;
            width: max-content;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            z-index: 111;

            @media (max-width: 1199px) {
                position: static;
                box-shadow: none;
                background: #efefef;
                width: 100%;
            }
        }

        .menu-link {
            font-weight: 800;
            color: #000;
            padding: 12px;
            margin: 0 10px;
            text-decoration: none;
            font-size: 13px;
            border-bottom: solid 4px transparent;

            &:hover {
                border-bottom: solid 4px #000;
                z-index: 25;
                color: black;
            }
        }

        &.active {
            .dropdown-content {
                display: block !important;
            }
            .label-outer {
                border-bottom: 4px solid #000;
            }
        }
        // &:focus,
        // &:active,
        // &:visited {
        //     .dropdown-content {
        //         display: none !important;
        //     }
        //     .label-outer {
        //         border: none;
        //     }
        // }
    }

    .mobile-icon {
        background: #efefef;
        padding: 2px 6px 5px;
        text-align: center;
        color: #333;
        border-radius: 5px;
    }
`;

export { PromotionStyles, HeaderStyles, HeaderSearch, NavStyles };
